module.exports = __webpack_public_path__ + "static/media/logo.a6b857bf.svg";